module.exports = __webpack_public_path__ + "img/zh_ysyl.4e95f0ac.svg";